module.exports = __webpack_public_path__ + "images/emoji/whale2.97748cb13dcc13e4b968.png";